module.exports = __webpack_public_path__ + "static/media/shopify-confirmation-page.225f6c55.webp";